import React from 'react';
import Lottie from 'react-lottie';
import './Profile_Info_Lottie.css';
import * as animationData from './Profile_Info_Lottie.json';

function Profile_Info_Lottie(){
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
    
    return (
      <section className='main'>
            <div className='Profile_Info_Lottie_icon'>
                <Lottie className="me-auto"
                options={defaultOptions}        
                />       
        </div>
      </section>
    );
}
export default Profile_Info_Lottie;